import CustomIcon, { ICustomIconProps } from '../_CustomIcon';
import { ReactComponent as IconComponent } from './Icon.svg';

const AdminIcon = (props: ICustomIconProps) => <CustomIcon icon={IconComponent} {...props} />;

export default AdminIcon;
